import type { FaireProductEntity } from "../../entity_types/product";

export const p_e3fb5ec9r5: FaireProductEntity = {
  token: "p_e3fb5ec9r5",
  type: "product",
  name: "Sterling Silver 3.5ct Radiant Cut Moissanite Eternity Band Stackable 3 Piece Ring Set",
  brandToken: "b_75net88q84",
  brandName: "Atlanta Jewelers Supply",
  imageUrl:
    "https://cdn.faire.com/fastly/3b5df9f637d071d427eddf9d7e4b49e4a555d9c4438db4c15e158dbb64f0c618.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e036099228d8c08c3b5c783d968a0e8bd7362f956cbd0fa5d93e82522686a989.png",
    "https://cdn.faire.com/fastly/fa32ee30138a1d279b992d2782d6f738549205243f376710966c5a2bc9279743.png",
    "https://cdn.faire.com/fastly/3859e94867bc4d68d989391632b38e6061e092e30f78000a02572c725b375847.png",
    "https://cdn.faire.com/fastly/dfc13da12c554b1a25c9e883d21713e37767097af46fd4d439c166048303d0c3.png",
    "https://cdn.faire.com/fastly/99e11fc15c7815420ce429421b59593c9731c08c3057ffd89de496ce17bac4a5.png",
  ],
  priceDollars: 96.98,
  description:
    "Sterling silver 3-piece ring set featuring a stunning 3.5ct radiant cut moissanite solitaire (10mm x 7mm) as the centerpiece, paired with two complementary eternity bands. The first band showcases round bubble moissanite stones set continuously around the band, while the second features stationed round moissanite stones for layered versatility. Each piece is crafted in sterling silver with 14k gold plating available. Designed for stacking and mixing, this set delivers luxury sparkle with the durability and affordability moissanite offers.\n",
  tags: [],
  msrpDollars: 193.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:25.171Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
